import $ from 'jquery';

Drupal.behaviors.troaxProductGroupBehavior = {
  attach() {
    $('.product-group')
      .once('troaxProductGroupBehavior')
      .each((index, element) => this.productGroupBehavior(element));
  },

  productGroupBehavior() {
    // Constants.
    const readMoreLink = $('.product-group__header-link');
    const text = $('.product-group__header-text');
    const icon = $('.product-group__header-link > i');
    const textAndLink = readMoreLink.height() + text.height();

    if (text.height() > 135 && textAndLink > 185) {
      text.css('height', 135);
      readMoreLink.css('display', 'block');
    }

    function toggleReadMore(e) {
      e.preventDefault();
      text.toggleClass('product-group__header-text--expanded');
      icon.toggleClass('fa-chevron-down fa-chevron-up');
    }

    // Events
    readMoreLink.on('click', toggleReadMore);
  },
};
